// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TippyPopupStyle } from "@hardwoods/App/Components/Tippy/Interface";
import { color } from "@hardwoods/XDL/Utilities";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export const xngTooltipStyles: TippyPopupStyle = {
    main: {
        css: css`
            line-height: 0;
            display: inline-flex;
            .tippy-box {
                transition-duration: 500ms !important;
                background: ${color("common.white")};
                box-shadow: 0 0 8px 0 ${color("text.main", 0.25)};
                color: ${color("text.main")};
                border-radius: 2px;
                text-align: center;
                min-width: 100px;

                &:focus,
                > *:focus {
                    outline: none;
                }

                & > .tippy-content {
                    padding: 25px 15px;
                }

                & > .tippy-arrow {
                    color: ${color("common.white")};
                }

                ${TypographyStyle} {
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 19px;
                }
                
                &.ach-bank-entry-hint {
                    ${xScreen.gt("sm")} {
                        min-width: 500px;
                    }
                }
            }
        `,
    },
    elementWrapper: { outline: "none !important" },
};
